/** Validation a TEXT field carries beyond "is a string". Phone and SSN are masks, not formats. */
export enum TextFormat {
  EMAIL = 'EMAIL',
  URL = 'URL'
}
